import React from "react";
import PropTypes from "prop-types";
import FinicityConnect from "components/common/FinicityConnect";
import { useMutation } from "@apollo/react-hooks";
import { SUCCESS } from "utils/constants";
import { track } from "utils";
import { UPDATE_FINICITY_ACCOUNTS_BOOST } from "../mutations";

const FinicityConnectBoost = ({
  refetchBank,
  refetchBoostTransactions,
  setErrorMessage,
  refetching,
  setRefetching,
  openFinicity,
  setOpenFinicity,
}) => {
  const [updateFinicityAccountsBoost, { loading }] = useMutation(
    UPDATE_FINICITY_ACCOUNTS_BOOST,
  );
  const handleUpdateFinicity = async () => {
    if (loading || refetching) {
      return;
    }
    setErrorMessage("");
    setRefetching(true);

    let updateFinicityRes;
    try {
      updateFinicityRes = await updateFinicityAccountsBoost();
    } catch (err) {
      track("TOMO_BOOST_DASHBOARD_UPDATE_FINICITY_ACCOUNT_ERROR");
      setErrorMessage("Something went wrong. Please try again.");
      setRefetching(false);
      return;
    }

    const status = updateFinicityRes?.data?.updateFinicityAccountsTransactions?.status;
    if (status === SUCCESS) {
      track("TOMO_BOOST_DASHBOARD_UPDATE_FINICITY_ACCOUNT_SUCCESS");
      try {
        await Promise.allSettled([[refetchBank(), refetchBoostTransactions()]]);
      } catch(err) {
        track("TOMO_BOOST_DASHBOARD_REFETCH_ERROR");
        setErrorMessage("Something went wrong. Please try again.");
      }
    } else {
      track("TOMO_BOOST_DASHBOARD_UPDATE_FINICITY_ACCOUNT_ERROR");
      setErrorMessage("Something went wrong. Please try again.");
    }
    setRefetching(false);
  };

  return (
    <FinicityConnect
      openFinicity={openFinicity}
      setOpenFinicity={setOpenFinicity}
      aggregation
      buttonClassName="bg-boost-primary-500 px-4 py-2 rounded font-medium text-white w-full text-center"
      buttonText="Add Account"
      disabled={loading || refetching}
      onSuccess={() => {
        handleUpdateFinicity();
      }}
      onCancel={() => {
        handleUpdateFinicity();
      }}
      onError={(res) => {
        if (res?.code === 201) {
          handleUpdateFinicity();
        }
      }}
      onUserEvent={(res) => {
        if (res?.data?.action === "End" && res?.code === 201) {
          handleUpdateFinicity();
        }
      }}
    />
  );
};

FinicityConnectBoost.propTypes = {
  refetchBank: PropTypes.func,
  refetchBoostTransactions: PropTypes.func,
  setErrorMessage: PropTypes.func,
  refetching: PropTypes.bool,
  setRefetching: PropTypes.func,
};

FinicityConnectBoost.defaultProps = {
  refetchBank: () => {},
  refetchBoostTransactions: () => {},
  setErrorMessage: () => {},
  refetching: false,
  setRefetching: () => {},
};

export default FinicityConnectBoost;